//import $ from  "jquery";
import Masonry from "masonry-layout";
window.Masonry = Masonry;
//window.$ = window.jQuery = $;

$(document).ready(function () {
    // Assign Colorbox to elements


    var colorboxInitialWidth = '95%';
    var colorboxInitialHeight = '95%';

    $(".colorbox-group").colorbox({


        // Eigene Galerie per data-galerie (z. B. die Ergebnisse), sonst eine
        // gemeinsame: sonst blättert die Lightbox von den Fotos der Kinder in den Ablauf
        rel: function () {
            return $(this).data('galerie') || 'colorbox-group';
        },
        maxWidth: '90%',
        maxHeight: '90%',
        reposition: true,
        scalePhotos: true,
        current: "{current} / {total}",
        title:function(){
            var element = $.colorbox.element();
            return element.attr("data-description");
        },
        onOpen: function () {


            window.addEventListener('resize', function () {
                $.colorbox.close();
            })


            $("body").css({overflow: 'hidden'});
            // Add buttons when Colorbox opens
            $("body").append(`
<div id="customPrev">
    <span class="custom-arrow">
        <svg width="40" height="80" viewBox="0 0 40 80"><path d="M30 10 L10 40 L30 70" stroke="currentColor" stroke-width="1" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>
    </span>
</div>`);
            $("body").append(`
<div id="customNext">
    <span class="custom-arrow">
        <svg width="40" height="80" viewBox="0 0 40 80"><path d="M10 10 L30 40 L10 70" stroke="currentColor" stroke-width="1" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>
    </span>
</div>`);
            $("body").append(`
<div id="customClose">
    <span class="custom-arrow">
        <svg width="40" height="40" viewBox="0 0 40 40"><path d="M10 10 L30 30 M30 10 L10 30" stroke="currentColor" stroke-width="1" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>
    </span>
</div>`);


            // Bind the click events
            $("#customNext").click(function () {
                $.colorbox.next();
            });
            $("#customPrev").click(function () {
                $.colorbox.prev();
            });
            $("#customClose").click(function () {
                $.colorbox.close();
            });

            // Add swipe support
            let touchstartX = 0;
            let touchendX = 0;
            
            const colorboxWrapper = document.getElementById('colorbox');
            if (colorboxWrapper) {
                colorboxWrapper.addEventListener('touchstart', e => {
                    touchstartX = e.changedTouches[0].screenX;
                }, { passive: true });

                colorboxWrapper.addEventListener('touchend', e => {
                    touchendX = e.changedTouches[0].screenX;
                    if (touchendX < touchstartX - 50) {
                        $.colorbox.next();
                    }
                    if (touchendX > touchstartX + 50) {
                        $.colorbox.prev();
                    }
                }, { passive: true });
            }
        },
        onClosed: function () {
            $("body").css({overflow: ''});
            // Remove buttons when Colorbox closes

            $("#customNext").remove();
            $("#customPrev").remove();
            $("#customClose").remove();
        },
        previous: "",
        next: "",
        overlayClose: false,
        closeButton: false,


    });

});


// Konto-Menü im Kopfbereich schliessen, sobald daneben geklickt wird.
// <details> bleibt von sich aus offen — das ist der einzige Teil, den der
// Browser nicht selbst erledigt.
document.addEventListener('click', function (event) {
    document.querySelectorAll('details.user-menu[open]').forEach(function (menu) {
        if (!menu.contains(event.target)) {
            menu.removeAttribute('open');
        }
    });
});

// Themen-Browser auf der Bereichsseite.
// Am Schreibtisch: Themenliste links, das offene Thema rechts.
// Auf dem Handy: Drill-down — erst nur die Liste, ein Tipp oeffnet das Thema,
// "Alle Themen" oder die Zurueck-Taste fuehren zur Liste zurueck.
var themenBrowser = document.querySelector('.topic-browser');

function istSchmal() {
    return window.matchMedia('(max-width: 900px)').matches;
}

function zeigeThema(gewaehlt) {
    document.querySelectorAll('.topic-head').forEach(function (kopf) {
        kopf.setAttribute('aria-expanded', kopf.dataset.thema === gewaehlt);
    });
    document.querySelectorAll('.topic-panel').forEach(function (panel) {
        panel.hidden = panel.dataset.thema !== gewaehlt;
    });
    if (themenBrowser) themenBrowser.classList.add('thema-gewaehlt');
}

function zeigeListe() {
    if (themenBrowser) themenBrowser.classList.remove('thema-gewaehlt');
}

// Adresse -> Zustand. Die Adresse ist die einzige Wahrheit; so funktionieren
// Neuladen, geteilte Links und die Zurueck-Taste ohne Sonderfaelle.
function syncVomHash() {
    var slug = decodeURIComponent(location.hash.slice(1));
    var kopf = slug ? document.querySelector('.topic-head[data-slug="' + CSS.escape(slug) + '"]') : null;
    if (kopf) {
        zeigeThema(kopf.dataset.thema);
    } else {
        zeigeListe();
    }
}

if (themenBrowser) {
    document.querySelectorAll('.topic-head').forEach(function (kopf) {
        kopf.addEventListener('click', function () {
            // Auf dem Handy ein echter Navigationsschritt (Zurueck-Taste soll
            // zur Liste fuehren), am Schreibtisch nur ein Umschalten.
            if (istSchmal()) {
                history.pushState(null, '', '#' + kopf.dataset.slug);
                themenBrowser.scrollIntoView({block: 'start'});
            } else {
                history.replaceState(null, '', '#' + kopf.dataset.slug);
            }
            zeigeThema(kopf.dataset.thema);
        });
    });

    var zurueck = document.querySelector('.topic-zurueck');
    if (zurueck) {
        zurueck.addEventListener('click', function () {
            // Bewusst kein history.back(): wer direkt mit #thema-Link kam,
            // wuerde damit die Seite verlassen.
            history.pushState(null, '', location.pathname + location.search);
            zeigeListe();
        });
    }

    window.addEventListener('popstate', syncVomHash);
    syncVomHash();
}

// Burger und Drawer im Kopfbereich (nur Handy sichtbar)
var burger = document.querySelector('.nav-burger');
if (burger) {
    var drawerZu = function () {
        document.documentElement.classList.remove('drawer-offen');
        burger.setAttribute('aria-expanded', 'false');
    };
    burger.addEventListener('click', function () {
        var offen = document.documentElement.classList.toggle('drawer-offen');
        burger.setAttribute('aria-expanded', offen);
    });
    document.querySelector('.nav-overlay').addEventListener('click', drawerZu);
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') drawerZu();
    });
}

// ── Anwesenheitsliste ────────────────────────────────────────────────────────
// Der Browser redet nur mit WordPress (admin-ajax + Nonce); WordPress reicht
// mit dem CRM-Token weiter. Der Token taucht hier bewusst nirgends auf.

function awSenden(el, aktion, nutzlast) {
    var daten = new FormData();
    daten.append('action', 'um_anwesenheit');
    daten.append('nonce', el.dataset.nonce);
    daten.append('termin', el.dataset.termin);
    daten.append('aktion', aktion);
    daten.append('nutzlast', JSON.stringify(nutzlast));
    return fetch(el.dataset.ajax, {method: 'POST', body: daten, credentials: 'same-origin'})
        .then(function (r) { return r.json(); });
}

var awFormular = document.querySelector('.anwesenheit-formular');
if (awFormular) {
    // Anwesend/abwesend umschalten
    awFormular.querySelectorAll('.aw-kind-toggle').forEach(function (knopf) {
        knopf.addEventListener('click', function () {
            var kind = knopf.closest('.aw-kind');
            var neu = kind.dataset.anwesend === '1' ? '0' : '1';
            kind.dataset.anwesend = neu;
            kind.querySelector('.aw-kind-haken').classList.toggle('ist-anwesend', neu === '1');
        });
    });

    // Notizfeld je Kind ein-/ausblenden
    awFormular.querySelectorAll('.aw-kind-notiz-knopf').forEach(function (knopf) {
        knopf.addEventListener('click', function () {
            var feld = knopf.closest('.aw-kind').querySelector('.aw-kind-notiz');
            feld.hidden = !feld.hidden;
            if (!feld.hidden) feld.querySelector('textarea').focus();
        });
    });

    var meldung = awFormular.querySelector('.aw-meldung');
    function awMeldung(text, istFehler) {
        meldung.textContent = text;
        meldung.hidden = false;
        meldung.classList.toggle('ist-fehler', !!istFehler);
    }

    awFormular.querySelector('.aw-speichern').addEventListener('click', function () {
        var speichern = awFormular.querySelector('.aw-speichern');
        speichern.disabled = true;

        // Kompletter Formularstand, kein Diff — so verlangt es die API
        var eintraege = [];
        awFormular.querySelectorAll('.aw-kind').forEach(function (kind) {
            var notiz = kind.querySelector('.aw-kind-notiz textarea').value.trim();
            eintraege.push({
                student_id: parseInt(kind.dataset.student, 10),
                present: kind.dataset.anwesend === '1' ? 1 : 0,
                student_note: notiz || null,
            });
        });
        var gruppenNotiz = awFormular.querySelector('.aw-gruppennotiz').value.trim();

        awSenden(awFormular, 'speichern', {group_note: gruppenNotiz || null, entries: eintraege})
            .then(function (antwort) {
                if (antwort.success) {
                    window.location.href = awFormular.dataset.zurueck || '?anwesenheit';
                } else {
                    awMeldung(antwort.error || 'Speichern fehlgeschlagen.', true);
                    speichern.disabled = false;
                }
            })
            .catch(function () {
                awMeldung('Keine Verbindung — bitte noch einmal versuchen.', true);
                speichern.disabled = false;
            });
    });

    awFormular.querySelector('.aw-absagen').addEventListener('click', function () {
        var knopf = awFormular.querySelector('.aw-absagen');
        knopf.disabled = true;
        awSenden(awFormular, 'absagen', {cancelled: true}).then(function (antwort) {
            if (antwort.success) window.location.reload();
            else { awMeldung(antwort.error || 'Aktion fehlgeschlagen.', true); knopf.disabled = false; }
        });
    });
}

// Absagen oder reaktivieren ausserhalb des Formulars: abgesagte und kuenftige Termine
var awStatusKnopf = document.querySelector('.aw-status-knopf');
if (awStatusKnopf) {
    awStatusKnopf.addEventListener('click', function () {
        awStatusKnopf.disabled = true;
        var absagen = awStatusKnopf.dataset.abgesagt === '1';
        awSenden(awStatusKnopf, 'absagen', {cancelled: absagen}).then(function (antwort) {
            if (antwort.success) window.location.reload();
            else { alert(antwort.error || 'Aktion fehlgeschlagen.'); awStatusKnopf.disabled = false; }
        });
    });
}

// Rückmeldung an Ulrike: eigener Absende-Weg neben dem Formular, ohne Neuladen
var awRueckmeldung = document.querySelector('.aw-rueckmeldung');
if (awRueckmeldung) {
    var rmText = awRueckmeldung.querySelector('.aw-rueckmeldung-text');
    var rmKnopf = awRueckmeldung.querySelector('.aw-rueckmeldung-senden');
    var rmMeldung = awRueckmeldung.querySelector('.aw-meldung');
    var rmListe = awRueckmeldung.querySelector('.aw-rueckmeldung-liste');
    var rmArten = JSON.parse(awRueckmeldung.dataset.arten);

    function rmHinweis(text, istFehler) {
        rmMeldung.textContent = text;
        rmMeldung.hidden = false;
        rmMeldung.classList.toggle('ist-fehler', !!istFehler);
    }

    // textContent statt innerHTML: der Text kommt vom Lehrer
    function rmEintrag(meldung) {
        var eintrag = document.createElement('li');
        eintrag.className = 'aw-rueckmeldung-eintrag';
        [
            ['aw-rueckmeldung-art', rmArten[meldung.kind] || meldung.kind],
            ['aw-rueckmeldung-inhalt', meldung.text],
            ['aw-rueckmeldung-status', 'offen'],
        ].forEach(function (teil) {
            var span = document.createElement('span');
            span.className = teil[0];
            span.textContent = teil[1];
            eintrag.appendChild(span);
        });
        return eintrag;
    }

    rmKnopf.addEventListener('click', function () {
        var text = rmText.value.trim();
        if (!text) {
            rmHinweis('Bitte kurz beschreiben, worum es geht.', true);
            rmText.focus();
            return;
        }
        var art = awRueckmeldung.querySelector('input[name="aw-art"]:checked').value;
        rmKnopf.disabled = true;

        awSenden(awRueckmeldung, 'melden', {kind: art, text: text})
            .then(function (antwort) {
                if (antwort.success) {
                    rmListe.prepend(rmEintrag(antwort.report || {kind: art, text: text}));
                    rmListe.hidden = false;
                    rmText.value = '';
                    rmHinweis('Gesendet — Ulrike sieht es im CRM.');
                } else {
                    rmHinweis(antwort.error || 'Senden fehlgeschlagen.', true);
                }
                rmKnopf.disabled = false;
            })
            .catch(function () {
                rmHinweis('Keine Verbindung — bitte noch einmal versuchen.', true);
                rmKnopf.disabled = false;
            });
    });
}
